/** parseScheduledObservationsFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseScheduledObservationsFilters = (
  params /* URLSearchParams */
) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  id: params.get("id"), // id matches
  id_cnts: params.get("id_cnts"), // id contains this text
  schedule_id: params.get("schedule_id"), // observation id matches
  astrosite_id: params.get("astrosite_id"), // observation id matches
  object_type: params.get("object_type"),
  object_id: params.get("object_id"),
  priority: params.get("priority"),
  observed: params.get("observed"),
  sort_order: params.get("sort_order") || "DESC",
  sort_by: params.get("sort_by") || "date",
})
